import ButtonFavourite from './product-like.vue';
import { createApp } from 'vue';

export const productFavourite = () => {
	const product = document.querySelector('.product-layout');
	const button = product.querySelector('.product-info__like');

	if (!button) return;
	const { id } = product.dataset;
	const app = createApp(ButtonFavourite, { id });
	app.use(window.app.pinia);
	app.mount(button);
};
